import Topbar from "./Topbar";
import MobileSidebar from "./mobileSidebar";

export default function MobileLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen w-full text-(--neutral-900)">
      <div className="fixed top-0 left-0 right-0 z-50 bg-(--neutral-50) text-(--neutral-900)">
        <Topbar />
      </div>
      <div className="flex-1 w-full overflow-y-auto px-4 py-4 pt-20 pb-20 bg-(--surface-base) text-(--neutral-900)">
        {children}
      </div>
      <MobileSidebar />
    </div>
  );
}